import { publicApi } from 'lib/api'
import to from 'lib/to'

export const getCovenants = () => to(publicApi.get('/covenants.json'))
